<template>
  <div class="slideshow-container is-flex">
    <transition name="list">
      <div class="list-complete-item">
        <a
          :href="links[indexNumber]"
          target="_blank"
        ><img
          v-if="images[indexNumber]"
          ref="img"
          :src="images[indexNumber]"
          alt="AHL Poker"
        ></a>
      </div>
    </transition>
    <a
      class="prev"
      @click="previousItem()"
    >&#10094;</a>
    <a
      class="next"
      @click="nextItem()"
    >&#10095;</a>
  </div>
</template>

<script>
  import Item from './Item.vue'
  import axios from 'axios'

  export default {
    name: 'Carousel',
    components: {
      Item
    },
    props: ['user', 'token'],
    data() {
      return {
        images: [],
        links: [],
        comments: [],
        indexNumber: 0,
        intervalId: ''
      }
    },
    mounted() {
      this.intervalId = setInterval(() => {
        this.nextItem()
      }, 5000)
      this.getItems()
    },
    beforeDestroy() {
      clearInterval(this.intervalId)
    },
    methods: {
      getItems() {
        let token = ''
        if (this.token) {
          token = this.token
        }
        this.$axios({
          method: 'POST',
          url: 'general',
          data: {
            token
          }
        })
          .then((res) => {
            for (let i = 0; i < res.data.upcomingEvents.length; i++) {
              this.images.push(res.data.upcomingEvents[i].image)
              this.links.push(res.data.upcomingEvents[i].url)
              this.comments.push(res.data.upcomingEvents[i].comments)
            }
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
          })
      },
      nextItem() {
        if (this.$refs.img) {
          this.$refs.img.className = 'fade'
        }
        if (this.indexNumber < this.images.length - 1) {
          this.indexNumber++
        } else this.indexNumber = 0
        setTimeout(() => {
          if (this.$refs.img) {
            this.$refs.img.classList.remove('fade')
          }
        }, 3000)
      },
      previousItem() {
        if (this.$refs.img) {
          this.$refs.img.className = 'fade'
        }
        if (this.indexNumber !== 0) {
          this.indexNumber--
        } else this.indexNumber = this.images.length - 1
      }
    }
  }
</script>
<style>
  .fade {
    -webkit-animation-name: fade;
    -webkit-animation-duration: 3s;
    animation-name: fade;
    animation-duration: 3s;
  }

  @-webkit-keyframes fade {
    from {
      opacity: .1
    }
    to {
      opacity: 1
    }
  }

  @keyframes fade {
    from {
      opacity: .1
    }
    to {
      opacity: 1
    }
  }

  /*@-webkit-keyframes fade {*/
  /*from {transform: translate(0,0)}*/
  /*to {transform: translate(1000px,0)}*/
  /*}*/

  /*@keyframes fade {*/
  /*from {transform: translate(0,0)}*/
  /*to {transform: translate(1000px,0)}*/
  /*}*/
</style>
